import {useState} from 'react';
import './App.css'; 
import {db} from './firebaseconfig.js'; 
import {addDoc,collection} from 'firebase/firestore';
function Addcomp(props){
         const [title,SetTitle]=useState();
         const [note,SetNote]=useState();  
         const collectionref=collection(db,"Notes");
         const Add=async ()=>{
               let Data={Title:title,Note:note};  
               let notes=props.notes;
               let setnotes=props.setnotes;
               let setcase=props.setcase;
               if(title!=null&&note!=null)  
               {
                  notes.push(Data);    
               }
               setnotes(notes);
               SetTitle('');
               SetNote('');
               setcase('mainpage');  
               await addDoc(collectionref,Data);   
         }
         return (
            <div className="div">
                 <input type="text" className="inp-title" onChange={(e)=>{SetTitle(e.target.value)}} placeholder="Title" maxLength={30} value={title}></input>   
                 <textarea type="text" className="inp-note" value={note} onChange={(e)=>{SetNote(e.target.value)}}maxLength={700} placeholder="Note" ></textarea>  
                 <button className="save-button" onClick={Add}>Save</button>  
            </div>    
         );
}
export default Addcomp;  